import React, { PureComponent } from 'react';
// Components
import Button from './button';

interface FabButtonProps {}
export default class FabButton extends PureComponent<FabButtonProps> {
  render() {
    const { icon, link, onClick } = this.props;
    return (
      <Button
        style={{ position: 'fixed', bottom: 10, right: 10 }}
        circle
        big
        icon={icon}
        link={link}
        onClick={onClick}
      />
    );
  }
}
